import {Component, Input} from '@angular/core';
import {ProductDetail} from '../../generic/classes/product.detail';
import {ProductTipType} from './product.tip.type';

interface ProductTip {
	text: string | null;
	icon: string | null;
}

@Component({
	selector: 'product-detail-extra-information',
	templateUrl: 'productdetail.extra.information.component.html',
	styleUrls: ['productdetail.extra.information.component.scss'],
	standalone: true,
})
export class ProductDetailExtraInformationComponent {
	@Input() productDetail: ProductDetail;

	public productTips(): ProductTip[] {
		return [
			this.createProductTip(
				this.productDetail.plantscapingAgeInfo,
				ProductTipType.AGE,
			),
			this.createProductTip(
				this.productDetail.plantscapingConsumptionInfo,
				ProductTipType.CONSUMPTION,
			),
			this.createProductTip(
				this.productDetail.plantscapingCuttingInfo,
				ProductTipType.CUTTING,
			),
			this.createProductTip(
				this.productDetail.plantscapingLocationInfo,
				ProductTipType.LOCATION,
			),
			this.createProductTip(
				this.productDetail.plantscapingFoodInfo,
				ProductTipType.NUTRITION,
			),
			this.createProductTip(
				this.productDetail.plantscapingOrigin,
				ProductTipType.ORIGIN,
			),
			this.createProductTip(
				this.productDetail.plantscapingTemperatureInfo,
				ProductTipType.TEMPERATURE,
			),
			this.createProductTip(
				this.productDetail.plantscapingWateringInfo,
				ProductTipType.WATER_AMOUNT,
			),
		];
	}

	/**
	 * Filters out any tip that has 'undefined' as text.
	 */
	public filteredProductTips(): ProductTip[] {
		return this.productTips().filter(
			productTip => productTip.text !== undefined,
		);
	}

	/**
	 * Check if all tips in the array have 'undefined' as text.
	 */
	public allTipsEmpty(): boolean {
		return this.productTips().every(productTip => !productTip.text);
	}

	/**
	 * Creates a product tip object.
	 *
	 * @param text
	 * @param type
	 * @private
	 */
	private createProductTip(
		text: string | null,
		type: ProductTipType,
	): ProductTip {
		return {
			text,
			icon: `/images/caretips/${this.productTipIcon(type)}`,
		};
	}

	/**
	 * Returns the icon for the product tip.
	 *
	 * @param type
	 * @private
	 */
	private productTipIcon(type: ProductTipType): string | null {
		switch (type) {
			case ProductTipType.AGE:
				return 'age.png';
			case ProductTipType.WATER_AMOUNT:
				return 'amount_of_water.png';
			case ProductTipType.CONSUMPTION:
				return 'consumption.png';
			case ProductTipType.ORIGIN:
				return 'country_of_origin.png';
			case ProductTipType.LOCATION:
				return 'location.png';
			case ProductTipType.NUTRITION:
				return 'nutrition.png';
			case ProductTipType.TEMPERATURE:
				return 'temperature.png';
			case ProductTipType.CUTTING:
				return 'trimming.png';
			default:
				return null;
		}
	}
}
